export default __webpack_public_path__ + "static/media/npm.87689eab.svg";